import * as UI from "@accurx/design";
import styled from "styled-components";

export const StyledNameText = styled(UI.Text).attrs(() => ({
    variant: "note",
    skinny: true,
}))`
    line-height: 1;
`;
